import { render, staticRenderFns } from "./CoTwoTehnicalProductionForm.vue?vue&type=template&id=06071c0e&scoped=true&"
import script from "./CoTwoTehnicalProductionForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTehnicalProductionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06071c0e",
  null
  
)

export default component.exports